module.exports = __webpack_public_path__ + "img/12.5d4befe2.gif";